import { Experiment } from '@ms/yammer-data/dist/state/types';
import { useExperimentTreatmentWithoutReporting } from '@ms/yammer-hooks/dist/experiments';
import { useIsNewGroupFilesEnabled } from '@ms/yammer-hooks/dist/groups';
import RedirectToFeed from '@ms/yammer-web-components/dist/route/RedirectToFeed';
import {
  LegacyCreateGroup,
  LegacyDiscoverGroups,
  LegacyGroupDelete,
  LegacyGroupFiles,
  LegacyGroupInfo,
  LegacyGroupInsights,
  LegacyGroupSettings,
  LegacyNetworkAdminSettings,
  LegacyUserSettings,
} from '@ms/yammer-web-components/dist/route/legacyRoutes';
import {
  searchPathFiles,
  searchPathGroups,
  searchPathInbox,
  searchPathThreads,
  searchPathTopics,
  searchPathUsers,
} from '@ms/yammer-web-support/dist/urls';
import React, { FC } from 'react';
import { Route, Switch } from 'react-router-dom';

import {
  DelegationSettings,
  DiscoverGroups,
  Group,
  Home,
  Inbox,
  LegacyRouteConverter,
  LegacyRouter,
  Questions,
  Search,
  StorylineRouter,
  Thread,
  Topic,
  UsagePolicy,
  User,
} from './loadableComponents';

export const ContentRoutes: FC = () => {
  const isNewGroupFilesEnabled = useIsNewGroupFilesEnabled();
  const isQuestionsPageEnabled = useExperimentTreatmentWithoutReporting(Experiment.VivaEngageQnA) === true;

  const legacyGroupFilesPage = !isNewGroupFilesEnabled ? (
    <Route exact={true} path="/groups/:groupId/files" component={LegacyGroupFiles} />
  ) : null;

  const questionsPage = isQuestionsPageEnabled ? <Route exact={true} path="/questions" component={Questions} /> : null;

  return (
    <Switch>
      <Route exact={true} path="/feed" component={Home} />
      <Route exact={true} path="/inbox" component={Inbox} />
      <Route exact={true} path="/inbox/:inboxFeedSubRoute" component={Inbox} />
      <Route exact={true} path="/create-group" component={LegacyCreateGroup} />
      <Route exact={true} path="/groups/:groupId" component={Group} />
      <Route exact={true} path="/groups/:groupId/settings" component={LegacyGroupSettings} />
      <Route exact={true} path="/groups/:groupId/delete" component={LegacyGroupDelete} />
      <Route exact={true} path="/groups/:groupId/info" component={LegacyGroupInfo} />
      <Route exact={true} path="/groups/:groupId/insights" component={LegacyGroupInsights} />
      {legacyGroupFilesPage}
      <Route exact={true} path="/groups/:groupId/:groupFeedSubRoute" component={Group} />
      <Route exact={true} path="/threads/:threadId/:topLevelMessageId?/:secondLevelMessageId?" component={Thread} />
      <Route exact={true} path="/users/:userId" component={User} />
      <Route exact={true} path="/users/:userId/:userFeedSubRoute" component={User} />
      <Route exact={true} path="/topics/:topicId" component={Topic} />
      <Route exact={true} path="/topics/:topicId/:topicFeedSubRoute" component={Topic} />
      <Route exact={true} path="/usage-policy" component={UsagePolicy} />
      <Route exact={true} path="/user-settings" component={LegacyUserSettings} />
      <Route exact={true} path="/user-settings/delegates" component={DelegationSettings} />
      <Route exact={true} path="/network-admin" component={LegacyNetworkAdminSettings} />
      <Route exact={true} path="/discover-groups" component={DiscoverGroups} />
      <Route exact={true} path="/discover-groups/:discoverGroupsSubRoute" component={DiscoverGroups} />
      <Route exact={true} path={searchPathThreads} component={Search} />
      <Route exact={true} path={searchPathGroups} component={Search} />
      <Route exact={true} path={searchPathUsers} component={Search} />
      <Route exact={true} path={searchPathFiles} component={Search} />
      <Route exact={true} path={searchPathTopics} component={Search} />
      <Route exact={true} path={searchPathInbox} component={Search} />
      {questionsPage}
      <Route exact={true} path="/:networkPermaLink/legacy/groups/:groupId/info" component={LegacyGroupInfo} />
      <Route exact={true} path="/:networkPermaLink/legacy/create-group" component={LegacyCreateGroup} />
      <Route exact={true} path="/:networkPermaLink/legacy/groups" component={LegacyDiscoverGroups} />
      <Route exact={true} path="/:networkPermaLink/users/:userId/storyline" component={StorylineRouter} />
      <Route exact={true} path="/:networkPermaLink/:entityType/:entityId/legacy/*" component={LegacyRouter} />
      <Route exact={true} path="/:networkPermaLink/legacy/:entityType/:entityId" component={LegacyRouter} />
      <Route exact={true} path="/:networkPermaLink/legacy/:entityType" component={LegacyRouter} />
      <Route exact={true} path="/:networkPermaLink/legacy/:entityType/show" component={LegacyRouter} />
      <Route exact={true} path="/:networkPermaLink/legacy/:entityType/inGroup" component={LegacyRouter} />
      <Route exact={true} path="/" component={RedirectToFeed} />
      <Route exact={false} path="*" component={LegacyRouteConverter} />
    </Switch>
  );
};

export default ContentRoutes;
